export default  {
	API_URL : 'https://api.tritongn.com'
}
